"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var Count = function Count(_ref) {
  var count = _ref.count,
      customClass = _ref.customClass;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('instant-search__results-count', customClass)
  }, count);
};

var _default = Count;
exports.default = _default;